export class WorkspaceOwnerChangedError extends Error {
  constructor() { super("Workspace owner changed"); this.name = "WorkspaceOwnerChangedError"; }
}

/** The authenticated route rejected this attempt before opening storage. */
export class WorkspaceRequestRejectedError extends Error {
  constructor(readonly status: 400 | 413) {
    super("This workspace change could not be saved. Adjust it and try again.");
    this.name = "WorkspaceRequestRejectedError";
  }
}
